<template>
  <div class="myCollectionGroup">

    <!-- 담겨있는 그룹 아이템 -->
    <div class="collectionNavCategory"
      :style="categoryStyle">
      <div class="categoryWrap"
        :style="listStyle">
        <div class="categoryList" :style="categoryHeight">
          <div
            v-for="item in items"
            :key="item.orderItemId || item.collectionItemId"
            class="categoryItem">
            {{ item.myCollectionName }}
          </div>
        </div>
      </div>
    </div>

    <!-- addCompare 상태 -->
    <div v-if="isComparedGroup" class="classPages">
      <div class="comparedItem">
        <!-- 썸네일 인디케이터 -->
        <div class="thumbnailSwiper">
          <div
            v-for="(item, index) in comparedThumbnails"
            :key="`thumb-${item.orderItemId || item.subItemId}`"
            :class="{ thumbnailImage: true, active: activeIndex === index }"
            @click="selectSlide(index)">
            <img
              v-if="item.image"
              :src="item.image"
              alt="">
          </div>
        </div>
        <!-- 메인 이미지 -->
        <swiper
          ref="mainSwiper"
          :options="mainSwiperOption"
          class="mainSwiper"
          @slideChange="onMainSlideChange">
          <swiper-slide
            v-for="item in comparedThumbnails"
            :key="`main-${item.orderItemId || item.subItemId}`">
            <div class="mainItem">
              <div class="mainImage">
                <img
                  v-if="item.image"
                  :src="item.image"
                  alt="">
              </div>
              <div class="mainInfo">
                <div class="className" :style="letterSpacing">
                  {{ item.collectionClassName[lang] }}
                </div>
                <div class="itemName">
                  {{ item.collectionItemName[lang] }}
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div class="totalPrice">{{ priceFormat(comparedItem.totalPrice) }}</div>
      </div>
    </div>

    <!-- 분류 기준 풀페이지 -->
    <div v-else class="classPages">
      <div v-for="classGroup in classGroups"
        :key="classGroup.collectionClassId"
        class="classPage"
        :class="{
          isRequired: classGroup.isRequired,
          isPassed: isPassed(classGroup.collectionClassId)
        }">

        <div class="classHeader">
          <span class="className" :style="letterSpacing">
            {{ classGroup.collectionClassName
              ? classGroup.collectionClassName[lang]
              : ''
            }}
          </span>
        </div>

        <div class="classItems">
          <div
            v-for="groupItem in classGroup.items"
            :key="groupItem.orderItemId || groupItem.collectionItemId"
            class="groupClassItem"
            :class="{
              isEmpty: !groupItem.selectedSubItems.length,
              isChecked: isChecked(
                classGroup.collectionClassId,
                groupItem.orderItemId
              )
            }">
            <CollectionButton v-if="groupItem.selectedSubItems.length"
              :is-active="isChecked(
                classGroup.collectionClassId,
                groupItem.orderItemId
              )"
              @click="toggleClassItem(classGroup, groupItem)" />
            <div class="subItems"
              @mouseenter="setHoverGroupItem($event, groupItem.orderItemId)"
              @mouseleave="unsetHoverGroupItem">
              <CollectionGroupItem
                v-for="subItem in groupItem.selectedSubItems"
                :key="subItem.orderItemId || subItem.subItemId"
                :locale="locale"
                :lang="lang"
                :item="subItem"
                :categoryId="categoryId"
                :groupOrderItemId="groupItem.orderItemId"
                :isChecked="isChecked(
                  classGroup.collectionClassId,
                  groupItem.orderItemId
                )"
                :isCompareItem="true"
                @setDetailGroupItemGallery="setDetailGroupItemGallery"
                @deleteItem="$emit('deleteItem', $event)" />
            </div>
          </div>
        </div>
      </div>

      <!-- 그룹아이템별 합계금액 -->
      <div class="groupItemPrice">
        <div
          v-for="item in items"
          :key="item.orderItemId || item.collectionItemId"
          class="price">
          {{ priceFormat(item.totalPrice) }}
          <!-- <button
            type="button"
            class="btnDelete"
            :class="{isVisible: item.orderItemId === hoveredGroupItem}"
            :style="letterSpacing"
            @click="$emit('deleteItem', item.orderItemId)">
            DELETE
          </button> -->
        </div>
      </div>

      <!-- 선택 결과 -->
      <div
        v-if="selectedTotalPrice > 0 && classGroups.length > 1"
        class="totalSelected"
        :class="{ centered: !requiredSelected }">
        <span :style="letterSpacing">PRICE</span>
        <span class="bar">|</span>
        <span>{{ priceFormat(selectedTotalPrice) }}</span>
      </div>
    </div>

    <!-- 새로운 마이컬렉션 저장 -->
    <div class="myCollectionGroupBtns"
      :class="{isShowBtns: isShowBtns}"
      @mouseenter="showBtns"
      @mouseleave="hideBtns">
      <div class="myCollectionInput">
        <template
          v-if="!isComparedGroup">
          <input
            v-model.trim="myCollectionName"
            type="text"
            class="input"
            :disabled="isSubmitting"
            @focus="focusedInput = true"
            @blur="focusedInput = false"
            @keydown.enter.prevent.stop="createMyCollection">
          <button
            type="button"
            class="addMyCollection"
            :disabled="!validateOnSubmit || isSubmitting"
            @click.stop="createMyCollection">
            SAVE
          </button>
        </template>
        <template
          v-else>
          <button
            type="button"
            class="addMyCollection delete"
            @click.stop="deleteComparedGroup(comparedItem.orderItemId)">
            DELETE
          </button>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import CollectionGroupItem from './MyCollectionGroupItem'
import CollectionButton from './CollectionButton.vue'

export default {
  name: 'CollectionGroup',
  components: {
    swiper,
    swiperSlide,
    CollectionGroupItem,
    CollectionButton
  },
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'group',
    'isStaff'
  ],
  computed: {
    setting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    pageFrame () {
      return this.$store.getters['collection/getPageFrame']
    },
    pointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    categoryHeight () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        height: `${category && category.height}px`
      }
    },
    categoryStyle () {
      const setting = this.setting
      const category = setting && setting.category
      const fontFamily = (category && category.fontFamily && `${category.fontFamily.default}, ${category.fontFamily.default2}, ${category.fontFamily.default3}`) || ''
      const isMyCollection = this.isMyCollection
      const myCollectionSetting = this.getMyCollectionSetting
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return {
        ...this.letterSpacing,
        color: category && category.text && category.text.color,
        fontSize: `${category && category.text && category.text.size}px`,
        fontFamily: fontFamily,
        backgroundColor: isMyCollection ? (myCollectionSetting && myCollectionSetting.backgroundColor) : (category && category.backgroundColor)
      }
    },
    listStyle () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        paddingTop: '0.5em',
        paddingBottom: '0.5em',
        borderColor: category && category.borderColor,
        borderBottom: 'none'
      }
    },
    letterSpacing () {
      const setting = this.setting
      const category = setting && setting.category
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null
        return (numeric / 1000).toFixed(2)
      }
      return {
        letterSpacing: `${spacingToLts(category && category.text && category.text.spacing)}em`
      }
    },
    items () {
      return this.group.items || []
    },
    isComparedGroup () {
      return this.items.length === 1 &&
        !this.items[0].collectionItemId
    },
    comparedItem () {
      return this.isComparedGroup
        ? this.items[0]
        : null
    },
    mainSwiper () {
      return this.$refs.mainSwiper &&
        this.$refs.mainSwiper.swiper
    },
    thumbnailSwiper () {
      return this.$refs.thumbnailSwiper &&
        this.$refs.thumbnailSwiper.swiper
    },
    comparedThumbnails () {
      const item = this.comparedItem

      if (!item) {
        return []
      }

      return (item.subItems || []).reduce((result, classItem) => {
        ;(classItem.selectedSubItems || []).forEach(subItem => {
          result.push({
            collectionClassId: classItem.collectionClassId,
            collectionClassName: classItem.collectionClassName,

            subItemId: subItem.subItemId,
            orderItemId: subItem.orderItemId,

            collectionItemName:
              subItem.collectionItemName,

            image:
              subItem.attribute &&
              subItem.attribute.image
          })
        })

        return result
      }, [])
    },
    /**
     * 분류 기준으로 그룹 아이템 재편성
     *
     * class
     *   └ groupItem
     *       └ selectedSubItems
     */
    classGroups () {
      const items = this.items
      const classMap = {}
      const classOrder = []

      for (let i = items.length - 1; i >= 0; i--) {
        const groupItem = items[i]

        ;(groupItem.collectionClasses || []).forEach(classItem => {
          const classId = classItem.collectionClassId

          if (!classId || classMap[classId]) {
            return
          }

          classMap[classId] = {
            collectionClassId: classId,
            collectionClassName: classItem.collectionClassName,
            isRequired: classItem.isRequired === true,
            items: []
          }

          classOrder.push(classId)
        })
      }

      classOrder.forEach(classId => {
        items.forEach(groupItem => {
          const classItem = (groupItem.subItems || []).find(item => {
            return item.collectionClassId === classId
          })

          const selectedSubItems = classItem
            ? classItem.selectedSubItems || []
            : []

          classMap[classId].items.push({
            orderItemId: groupItem.orderItemId,
            collectionItemId: groupItem.collectionItemId,
            myCollectionName: groupItem.myCollectionName,
            totalPrice: groupItem.totalPrice || 0,
            selectedSubItems
          })
        })
      })

      return classOrder
        .map(classId => {
          const classGroup = classMap[classId]

          classGroup.isRequired =
            classGroup.isRequired &&
            classGroup.items.every(item => {
              return item.selectedSubItems.length > 0
            })

          return classGroup
        })
        .filter(classGroup => {
          return classGroup.items.some(item => {
            return item.selectedSubItems.length > 0
          })
        })
    },
    /**
     * 저장 API용 선택 데이터
     */
    selectedSubmitItems () {
      return Object.values(this.selectedClassItems)
        .filter(classItem => {
          return Array.isArray(classItem.selectedSubItems) &&
            classItem.selectedSubItems.length > 0
        })
        .map(classItem => {
          return {
            collectionClassId: classItem.collectionClassId,
            isRequired: !!classItem.isRequired,
            subItemIds: classItem.selectedSubItems
              .map(subItem => subItem.subItemId)
              .filter(Boolean)
          }
        })
        .filter(classItem => {
          return classItem.subItemIds.length > 0
        })
    },
    selectedTotalPrice () {
      return Object.values(this.selectedClassItems)
        .reduce((total, classItem) => {
          const classTotal = (classItem.selectedSubItems || [])
            .reduce((sum, subItem) => {
              return sum + Number(subItem.price || 0)
            }, 0)

          return total + classTotal
        }, 0)
    },
    hasPrice () {
      return this.items.some(item => {
        return Number(item.totalPrice || 0) > 0
      })
    },
    orderItemIds () {
      return [
        ...new Set(
          this.items
            .map(item => item.orderItemId)
            .filter(Boolean)
        )
      ]
    },
    requiredSelected () {
      const requiredClasses = this.classGroups.filter(classGroup => {
        return classGroup.isRequired
      })

      if (!requiredClasses.length) {
        return this.selectedSubmitItems.length > 0
      }

      return requiredClasses.every(classGroup => {
        const selected =
          this.selectedClassItems[classGroup.collectionClassId]

        return Array.isArray(selected && selected.selectedSubItems) &&
          selected.selectedSubItems.length > 0
      })
    },
    validateOnSubmit () {
      if (!this.myCollectionName.trim()) {
        return false
      }

      return this.requiredSelected
    }
  },
  data () {
    return {
      selectedClassItems: {},
      myCollectionName: '',
      isSubmitting: false,
      activeIndex: 0,
      mainSwiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 1,
        speed: 400
      },
      thumbnailSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true
      },
      isShowBtns: false,
      focusedInput: false,
      hoveredGroupItem: null
    }
  },
  methods: {
    setHoverGroupItem (e, groupItemId) {
      const target = e && e.relatedTarget
      // if (target.closest('.btnDelete')) {
      //   this.hoveredGroupItem = groupItemId
      //   return
      // }
      this.hoveredGroupItem = groupItemId
    },
    unsetHoverGroupItem (e) {
      const target = e && e.relatedTarget
      if (target.closest('.btnDelete')) {
        e.preventDefault()
        return
      }
      this.hoveredGroupItem = null
    },
    showBtns () {
      this.isShowBtns = true
    },
    hideBtns () {
      if (this.focusedInput) return
      this.isShowBtns = false
    },
    selectSlide (index) {
      if (!this.mainSwiper) {
        return
      }

      this.mainSwiper.slideTo(index)
    },

    onMainSlideChange () {
      if (!this.mainSwiper) {
        return
      }

      const index = this.mainSwiper.activeIndex

      this.activeIndex = index

      if (this.thumbnailSwiper) {
        this.thumbnailSwiper.slideTo(index)
      }
    },
    isPassed (classId) {
      const selected = this.selectedClassItems[classId]

      return !!(
        selected &&
        Array.isArray(selected.selectedSubItems) &&
        selected.selectedSubItems.length
      )
    },

    isChecked (classId, orderItemId) {
      const selected = this.selectedClassItems[classId]

      return !!(
        selected &&
        selected.parentOrderItemId === orderItemId
      )
    },

    /**
     * class별 하나의 그룹 아이템 선택
     */
    toggleClassItem (classGroup, groupItem) {
      if (!groupItem.selectedSubItems.length) {
        return
      }

      const classId = classGroup.collectionClassId
      const selected = this.selectedClassItems[classId]

      const isSameItem =
        selected &&
        selected.parentOrderItemId === groupItem.orderItemId

      if (isSameItem) {
        this.$delete(this.selectedClassItems, classId)

        return
      }

      this.$set(this.selectedClassItems, classId, {
        collectionClassId: classId,
        collectionClassName: classGroup.collectionClassName,
        isRequired: classGroup.isRequired,
        parentOrderItemId: groupItem.orderItemId,
        selectedSubItems: [
          ...groupItem.selectedSubItems
        ]
      })
    },

    priceFormat (price) {
      return this.$store.getters['util/getPriceFormatter'](price)
    },

    async saveSnapshot () {
      try {
        const data = {
          pageId: this.pageId,
          memo: '[auto] before compare item'
        }

        const res = await this.$store.dispatch(
          'collection/saveMyCollectionSnapshot',
          data
        )

        return res
      } catch (error) {
        console.error(error)

        return null
      }
    },

    async createMyCollection () {
      if (
        this.isSubmitting ||
        !this.validateOnSubmit
      ) {
        return
      }

      this.isSubmitting = true
      this.$store.commit('loading', true)

      const data = {
        pageId: this.pageId,
        collectionCategory: this.categoryId,

        compareOrderItemId: this.orderItemIds,

        myCollectionName: this.myCollectionName.trim(),

        subItems: this.selectedSubmitItems,

        collectionClasses: this.classGroups.map(classGroup => {
          return {
            collectionClassId: classGroup.collectionClassId,
            collectionClassName: classGroup.collectionClassName,
            isRequired: classGroup.isRequired
          }
        })
      }

      try {
        const snapshot = await this.saveSnapshot()

        if (!(snapshot && snapshot.status === 200)) {
          throw new Error(
            '마이콜렉션 자동 저장에 실패했습니다.'
          )
        }

        const res = await this.$store.dispatch(
          'collection/compareCollectionItem',
          data
        )

        if (!(res && res.status === 200)) {
          throw new Error(
            '새 마이콜렉션 항목 저장에 실패했습니다.'
          )
        }

        await this.$store.dispatch(
          'collection/getMyCollectionItems',
          {
            pageId: this.pageId
          }
        )

        this.myCollectionName = ''
        this.selectedClassItems = {}

        this.$emit('completeCompare')
      } catch (error) {
        console.error(error)

        alert(
          error.message ||
          '마이콜렉션 저장 중 오류가 발생했습니다.'
        )
      } finally {
        this.isSubmitting = false
        this.$store.commit('loading', false)
      }
    },

    deleteComparedGroup (orderItemId) {
      if (!window.confirm('삭제하시겠습니까?')) return
      this.$emit('deleteItem', orderItemId)
    },

    setDetailGroupItemGallery ({ subItemId }) {
      if (!subItemId) {
        return
      }

      const imageList = []
      let startIndex = 0
      let found = false

      this.classGroups.forEach(classGroup => {
        classGroup.items.forEach(groupItem => {
          groupItem.selectedSubItems.forEach(item => {
            const image =
              item.attribute &&
              item.attribute.image

            if (!image) {
              return
            }

            if (
              !found &&
              item.subItemId === subItemId
            ) {
              startIndex = imageList.length
              found = true
            }

            imageList.push({
              image,
              subItemId: item.subItemId,
              collectionItemName:
                item.collectionItemName
            })
          })
        })
      })

      this.$store.commit(
        'collection/setDetailGroupItemGallery',
        {
          type: 'item',
          imageList,
          startIndex
        }
      )
    }
  }
}
</script>